import { BasePolyfill } from './BasePolyfill';

class IntersectionObserver extends BasePolyfill {
  public execute = !('IntersectionObserver' in window);
  public polyfill = () => import('intersection-observer');
}

export { IntersectionObserver };
